var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9709 20.1428L17.5104 21.9701C15.2477 20.6396 13.3618 18.7537 12.0313 16.491L13.8586 15.0305C14.2988 14.678 14.4461 14.073 14.2171 13.5576L12.5526 9.80924C12.3061 9.25392 11.6939 8.95861 11.1059 9.11142L7.93397 9.93888C7.31976 10.0958 6.92256 10.6905 7.01274 11.318C8.15722 19.4532 14.5531 25.8457 22.6889 26.9859C23.3164 27.0761 23.911 26.6789 24.068 26.0646L24.8955 22.8927C25.0475 22.3051 24.7523 21.6938 24.1976 21.4474L20.4437 19.7856C19.9287 19.5563 19.3237 19.703 18.9709 20.1428Z",
    stroke: "#565CA8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0359 11.1387C20.7017 11.1387 22.8627 13.2997 22.8627 15.9655",
    stroke: "#565CA8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0359 7.0014C20.4133 7.0014 22.6934 7.94584 24.3745 9.62693C26.0556 11.308 27 13.5881 27 15.9655",
    stroke: "#565CA8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/Phone.b9650943.svg";
export { ForwardRef as ReactComponent };